import { render, staticRenderFns } from "./switch-date-month.vue?vue&type=template&id=6ffda1f5&"
import script from "./switch-date-month.vue?vue&type=script&lang=js&"
export * from "./switch-date-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ffda1f5')) {
      api.createRecord('6ffda1f5', component.options)
    } else {
      api.reload('6ffda1f5', component.options)
    }
    module.hot.accept("./switch-date-month.vue?vue&type=template&id=6ffda1f5&", function () {
      api.rerender('6ffda1f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-date-picker/src/panel/switch-date-month.vue"
export default component.exports